export class FetchError extends Error {
  /** @type {number} */
  status;

  /**
   * @param {Response} response
   * @param {ErrorOptions | undefined} [options]
   */
  constructor(response, options) {
    super(response.statusText, options);

    this.status = response.status;
  }
}

/**
 * Fetch but throws a {@link FetchError} if the response is unsuccessful
 * @param {string | URL | globalThis.Request} input
 * @param {RequestInit} [init]
 * @returns {Promise<Response>}
 */
export async function fetchWithCheck(input, init) {
  const response = await fetch(input, init);
  if (!response.ok) {
    throw new FetchError(response);
  }

  return response;
}
